/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  checkbox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#ffffff',
  },
  checkedBox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#27ae60',
  },
  checkboxText: {
    fontSize: 9,
    color: '#2c3e50',
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  signatureBox: {
    width: '45%',
    padding: 10,
    border: '1px solid #bdc3c7',
    borderRadius: 5,
  },
  signatureTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#34495e',
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  },
  
});

const ExportPDFStandardEmploymentContract = ({ user, data, agencyInfo }) => {

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <HeaderPDF user={user} agencyInfo={agencyInfo} />
        <Text style={styles.title}>Standard Employment Contract</Text>
        
        {/* Section A: Particulars of Parties */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Section A: Particulars of Parties</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employer Name:</Text>
              <Text style={styles.value}>{data.employerName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Employer ID:</Text>
              <Text style={styles.value}>{data.employerId || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employer Address:</Text>
              <Text style={styles.value}>{data.employerAddress || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>FDW Name:</Text>
              <Text style={styles.value}>{data.fdwName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>FDW Work Permit:</Text>
              <Text style={styles.value}>{data.fdwWp || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>FDW Passport:</Text>
              <Text style={styles.value}>{data.fdwPassport || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Section B: Terms of Contract */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Section B: Terms of Contract</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employment Period:</Text>
              <Text style={styles.value}>{data.employmentPeriod || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>FDW Responsibilities:</Text>
              <Text style={styles.value}>{data.fdwResponsibilities || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Salary:</Text>
              <Text style={styles.value}>{data.salary || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Rest Compensation:</Text>
              <Text style={styles.value}>{data.restComp || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Salary Date:</Text>
              <Text style={styles.value}>{data.salaryDate || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Payment Method:</Text>
              <Text style={styles.value}>{data.payMethod || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Responsibilities of the Employer */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Responsibilities of the Employer</Text>
          <View style={styles.checkboxContainer}>
            <View style={data.meals ? styles.checkedBox : styles.checkbox} />
            <Text style={styles.checkboxText}>Provide meals</Text>
          </View>
          <View style={styles.checkboxContainer}>
            <View style={data.rest ? styles.checkedBox : styles.checkbox} />
            <Text style={styles.checkboxText}>Provide rest</Text>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Accommodation:</Text>
              <Text style={styles.value}>{data.accommodation || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employer Responsibilities:</Text>
              <Text style={styles.value}>{data.employerResp || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Rest Days */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Rest Days</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Daily Wage:</Text>
              <Text style={styles.value}>{data.dailyWage || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Contract Clauses */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Contract Clauses</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Termination:</Text>
              <Text style={styles.value}>{data.termination || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Extension:</Text>
              <Text style={styles.value}>{data.extension || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Others:</Text>
              <Text style={styles.value}>{data.others || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Signatures */}
        <View style={styles.signatureSection}>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureTitle}>Section C: Employer&apos;s Declaration</Text>
            <Text style={styles.label}>Employer Signature:</Text>
            <Text style={styles.value}>{data.employerSignature || ''}</Text>
            <Text style={styles.label}>Date:</Text>
            <Text style={styles.value}>{data.employerDate || ''}</Text>
            <Text style={styles.label}>EA Witness (Employer):</Text>
            <Text style={styles.value}>{data.eaWitnessEmp || ''}</Text>
            <Text style={styles.label}>EA Registration (Employer):</Text>
            <Text style={styles.value}>{data.eaRegEmp || ''}</Text>
          </View>

          <View style={styles.signatureBox}>
            <Text style={styles.signatureTitle}>Section D: FDW&apos;s Declaration</Text>
            <Text style={styles.label}>FDW Signature:</Text>
            <Text style={styles.value}>{data.fdwSignature || ''}</Text>
            <Text style={styles.label}>Date:</Text>
            <Text style={styles.value}>{data.fdwDate || ''}</Text>
            <Text style={styles.label}>EA Witness (FDW):</Text>
            <Text style={styles.value}>{data.eaWitnessFdw || ''}</Text>
            <Text style={styles.label}>EA Registration (FDW):</Text>
            <Text style={styles.value}>{data.eaRegFdw || ''}</Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Standard Employment Contract Generated on {new Date().toLocaleDateString()}</Text>
          {user && (
            <Text>Agency: {user.company?.name || 'Not specified'}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFStandardEmploymentContract;
